interface FilterGroupProps {
  label: string;
  options: (string | number)[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-3 last:border-b-0 md:flex-row md:items-start md:gap-4">
      <span className="flex w-full shrink-0 items-center gap-1.5 pt-1 text-sm font-semibold text-foreground-700 md:w-20">
        {label}
      </span>
      <div className="flex flex-wrap gap-1.5">
        <button
          type="button"
          onClick={() => onChange('')}
          className={`whitespace-nowrap rounded-md px-3 py-1 text-sm transition-colors ${
            value === ''
              ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
              : 'text-foreground-600 hover:bg-background-100'
          }`}
        >
          全部
        </button>
        {options.map((option) => {
          const optionValue = String(option);
          return (
            <button
              key={optionValue}
              type="button"
              onClick={() => onChange(optionValue)}
              className={`whitespace-nowrap rounded-md px-3 py-1 text-sm transition-colors ${
                value === optionValue
                  ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
                  : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}